import React, { useContext } from 'react';
import type { Activity, DirectLine } from 'botframework-directlinejs';
import { type BotServiceConfig, type ILogger } from '@bingads-webui/ads-copilot-shared-types';

export type TChatTriggerSource =
    | 'globalMenu'
    | 'conversionDeliveryStatusPopup'
    | 'apexHelpDropdownCopilotButton'
    | 'summarize'
    | 'globalSearchCopilotIcon'
    | 'globalSearchCopilotLink'
    | 'globalSearchCopilotQuestionSuggestion'
    | 'liveAgentLinkInGlobalHelpMenu'
    | 'liveAgentLinkInHelpApexPanel'
    | 'helpApexCopilotIcon'
    | 'helpApexCopilotLink'
    | 'helpApexCopilotQuestionSuggestion'
    | 'pmaxSignupLiveAgent'
    | 'fraudSignupLiveAgent'
    | 'startOverIcon'
    | 'chatHistoryResume'
    | 'conversationResume'
    | 'conversionTagTroubleshootingInactive'
    | 'conversionTagTroubleshootingUnverified'
    | 'conversionAllTagsGridInactive'
    | 'conversionAllTagsGridUnverified'
    | 'conversionGoalsTagUnverified'
    | 'campaignGridTagInactive'
    | 'adsCopilotTeachingBubbleV1'
    | 'adsCopilotTeachingBubbleV2'

export interface IAdsCopilotContextValue {
  activities: Activity[]; // DEPRECATED, DO NOT USE
  botServiceConfig?: BotServiceConfig;
  logger?: ILogger;
  onBotServiceConfigChange?: (botServiceConfig: BotServiceConfig | undefined) => void;
  onDirectLineCreated: (directLine: DirectLine, username: string, logger?: ILogger) => void;
  pilotMap?: Record<string, boolean>;
  onPilotMapChange?: (pilotMap: Record<string, boolean>) => void;
  onIsSendDisabledChange?: (disabled: boolean) => void;
  isSendDisabled?: boolean;
  chatTriggerSource?: TChatTriggerSource;
  onChatTriggerSourceChange?: (chatTriggerSource: TChatTriggerSource) => void;
}

export const AdsCopilotContext = React.createContext<IAdsCopilotContextValue | undefined>(undefined);

export const useAdsCopilotContext = () => useContext(AdsCopilotContext);
